<div class="itemDetailsContainer">
  <div class="topOptionBar">
    <span class="close" (click)="closePopup()">✕</span>
  </div>
  
  <div class="titleDescription">
    @if(item) {
      <div class="itemNameTitle">
        {{ item.item.itemName.translations[translationService.getLanguage()] }}
      </div>
      <div class="itemDescription" [innerHTML]="item.item.description.translations[translationService.getLanguage()]">
        
      </div>
    }
  </div>

  
  <!--
  @if(this.nutritions) {
    <div class="dropDownInfo" [class.open]="isOpen">
      <div class="dropDownTitle" (click)="expandDetails()">
        <div class="sectionTitle">
          {{ 'Allergy Information' }}
        </div>
        <div class="sectionArrow">
          <span class="arrow" [class.open]="isOpen">▾</span>
        </div>
      </div>
      <div class="dropDownContent" >
        
        <div class="containsContent">
          {{ 'Contains: ' + getAllergensContainName() }}
        </div>
        <div class="mayContainsContent">
          {{ 'Ingredients may contain: ' + getAllergensMayContainName() }}
        </div>
        <div class="descriptionContent">
          {{ 'description for the allergies risk or other information' }}
        </div>
      </div>
    </div>
  }
    -->

  @if(this.allergens) {
    <div class="dropDownInfo" [class.open]="true">
      <div class="dropDownTitle" (click)="expandDetails()">
        <div class="sectionTitle">
          {{ 'Allergy Information' }}
        </div>
        <!--
        <div class="sectionArrow">
          <span class="arrow" [class.open]="isOpen">▾</span>
        </div>
        -->
      </div>
      <div class="dropDownContent" >
        <div class="containsContent">
          {{ 'Contains: ' + getAllergensContainName() }}
        </div>
        <div class="mayContainsContent">
          {{ 'Ingredients may contain: ' + getAllergensMayContainName() }}
        </div>
        <div class="descriptionContent">
          {{ 'description for the allergies risk or other information' }}
        </div>
      </div>
    </div>
  }

  <!-- formated differently -->
  @if(this.nutritions) {
    <div class="dropDownInfo" [class.open]="true">
      <div class="dropDownTitle" (click)="expandDetails()">
        <div class="sectionTitle">
          {{ 'Nutrition Information' }}
        </div>
        <!--
        <div class="sectionArrow">
          <span class="arrow" [class.open]="isOpen">▾</span>
        </div>
        -->
      </div>
      <div class="dropDownContent" >
        @for(nutrition of nutritions.nutritions; track nutrition) {
          <div class="listContent">
            {{ nutrition.name.translations[translationService.getLanguage()] + ': ' + getNutritionForItem(nutrition) }}
          </div>
        }
        

      </div>
    </div>
  }

  @if(this.flavors) {
    <div class="dropDownInfo" [class.open]="true">
      <div class="dropDownTitle" (click)="expandDetails()">
        <div class="sectionTitle">
          {{ 'Flavors Information' }}
        </div>
        <!--
        <div class="sectionArrow">
          <span class="arrow" [class.open]="isOpen">▾</span>
        </div>
        -->
      </div>
      <div class="dropDownContent" >
        @if(getFlavorsForItem() != "") {
          <div class="listContent">
            {{ 'flavors available: ' + getFlavorsForItem() }}
          </div>
        }
      </div>
    </div>
  }

  
</div>